import { createUseStyles } from 'react-jss'

import { colors } from 'components/common'

const arrow = {
  display: 'inline-block',
  width: '10px',
  height: '10px',
  borderTop: '3px solid #ddd',
  borderRight: '3px solid #ddd',
  borderRadius: '2px'
}

const useWeekPickerStyles = createUseStyles({
  weekPickerWrapper: {
    display: 'flex',
    flexDirection: 'column',
    '& > label': {
      fontWeight: 'bold',
      color: colors.gray600,
      fontSize: 12,
      marginBottom: '0.5rem'
    }
  },
  weekPicker: {
    border: '1px solid #ddd',
    borderRadius: '4px',
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    height: '40px',
    minWidth: 200,
    background: '#fff',
    fontSize: 12
  },
  weekPickerDisabled: {
    opacity: 0.4,
    pointerEvents: 'none'
  },
  arrowWrapper: {
    display: 'flex',
    alignItems: 'center',
    padding: '0 15px',
    height: '100%',
    cursor: 'pointer',
    '& > i': {
      ...arrow
    },
    '& > i[data-arrow=left]': {
      transform: 'rotate(-135deg)'
    },
    '& > i[data-arrow=right]': {
      transform: 'rotate(45deg)'
    },
    '&:hover > i': {
      borderColor: '#000'
    }
  },
  label: {
    fontWeight: 'bold',
    color: '#000'
  }
})

export { useWeekPickerStyles }
